import React from 'react';
import styled from 'styled-components';

interface SectionInnerGridContentProps {
    children?: React.ReactNode;
    maxWidth?: number;
}

const Styled = styled.section<{maxWidth?: number}>`
    text-align: center;
    width: 80%;
    max-width: ${(p) => p.maxWidth || 864}px;
    margin: 0 auto;
    ${(p) => p.theme.breakpoints.down('md')} {
        width: 100%;
    }
`;

export const SectionInnerGridContent = ({
    children,
    maxWidth
}: SectionInnerGridContentProps): JSX.Element => {
    return <Styled maxWidth={maxWidth}>{children}</Styled>;
};
